import Axios from 'axios';
import Apis from '../../config/Apis';
import { hideLoading, showLoading, showAlert } from '../Actions/GeneralActions';
// import { headers } from '../../Utils';
import { getAnalytics, getReviews } from '../Actions/ReviewActions';
import { headers } from '../../utills';

export const ReviewMiddleware = {


    submitReview: (userData) => {
        return dispatch => {
            dispatch(showLoading())
            return new Promise(async (resolve, reject) => {
                try {
                    let formdata = new FormData();
                    formdata.append('vendor_id', userData?.vendor_id);
                    formdata.append('type', userData?.type);
                    formdata.append('review', userData?.feedback);
                    formdata.append('rating', userData?.rating);

                    const data = await Axios.post(Apis.ClientReviewsToVendor, formdata, await headers.config())
                    if (data?.status == 200) {
                        resolve(true)
                        dispatch(showAlert({type: "Success", message: data?.data?.message }))
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: 'submitReview',
                            message: error?.response?.data?.message,
                            type: 'Error',
                            status: error?.response?.status,
                        }),
                    );
                } finally {
                    dispatch(hideLoading())
                }
            })
        }
    },


    getReviewReponses: () => {
        return dispatch => {
            dispatch(showLoading())
            return new Promise(async (resolve, reject) => {
                try {
                    const data = await Axios.post(Apis.getVendorResponseList, {}, await headers.config())
                    if (data?.status == 200) {
                        dispatch(hideLoading())
                        // dispatch(showAlert({
                        //     type: "Success",
                        //     message: data?.data?.message
                        // }))
                        resolve(data?.data?.data)
                    }
                } catch (error) {
                    dispatch(hideLoading())
                    reject(error);
                    dispatch(
                        showAlert({
                            title: 'getReviewReponses',
                            message: error?.response?.data?.message,
                            type: 'Error',
                            status: error?.response?.status,
                        }),
                    );
                } 
            })
        }
    },

    getAnalytics: () => {
        return dispatch => {
          return new Promise(async (resolve, reject) => {
            try {
              const data = await Axios.post(Apis.getClientReviewsList, {}, await headers.config())
              if (data?.status == 200) {
                resolve(true)
                dispatch(getAnalytics(data?.data?.data))
              }
            } catch (error) {
              reject(error);
              dispatch(
                showAlert({
                  title: 'Get Analytics',
                  message: error?.response?.data?.message,
                  type: 'Error',
                  status: error?.response?.status,
                }),
              );
            }
          })
        }
      },

      getReviews: () => {
        return dispatch => {
          return new Promise(async (resolve, reject) => {
            try {
              const data = await Axios.post(Apis.getClientResponseList, {}, await headers.config())
              if (data?.status == 200) {
                resolve(data?.data?.data)
                dispatch(getReviews(data?.data?.data))
              }
            } catch (error) {
              reject(error);
              dispatch(
                showAlert({
                  title: 'getReviews',
                  message: error?.response?.data?.message,
                  type: 'Error',
                  status: error?.response?.status,
                }),
              );
            }
          })
        }
      },
    
      submitResponse: (userData) => {
        return dispatch => {
          dispatch(showLoading())
          return new Promise(async (resolve, reject) => {
            try {
              let formdata = new FormData();
              formdata.append('review_id', userData?.review_id);
              formdata.append('client_id', userData?.client_id);
              formdata.append('review_response', userData?.feedback);
    
              const data = await Axios.post(Apis.VendorReviewsToClient, formdata, await headers.config())
              if (data?.status == 200) {
                resolve(true)
                dispatch(getReviews(data?.data?.data))
                dispatch(showAlert({type:"success", message: data?.data?.message }))
              }
            } catch (error) {
              reject(error);
              dispatch(
                showAlert({
                  title: 'submitResponse',
                  message: error?.response?.data?.message,
                  type: 'Error',
                  status: error?.response?.status,
                }),
              );
            } finally {
              dispatch(hideLoading())
            }
          })
        }
      },



};